export default "__VITE_ASSET__CgpPdMNC__"